import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

const LEVEL = { guest: 0, member: 1, officer: 2, super_admin: 3 };

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [checked, setChecked] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
    } catch {
      setUser(false);
    } finally {
      setChecked(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.debug("Logout request failed", e); }
    setUser(false);
  };

  const hasRole = (min) => user && LEVEL[user.role] >= LEVEL[min];

  return (
    <AuthCtx.Provider value={{ user, setUser, checked, refresh, logout, hasRole }}>
      {children}
    </AuthCtx.Provider>
  );
}
